import { render, staticRenderFns } from "./my-order-tab.vue?vue&type=template&id=5b91e03a&scoped=true&"
import script from "./my-order-tab.vue?vue&type=script&lang=js&"
export * from "./my-order-tab.vue?vue&type=script&lang=js&"
import style0 from "./my-order-tab.vue?vue&type=style&index=0&id=5b91e03a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91e03a",
  null
  
)

export default component.exports